import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const About = () => {
  return (
    <>
      <Container className="mt-2 mr-lg-5 h-100" fluid>
        <h1 className="contact">About</h1>
        <Row className="h-100 justify-content-md-center">
          <Col className="my-auto" md="auto">
            <div className="px-lg-5 about-text text-justify">
              <p>
                A Front End Developer from Andhra. Have strong Knowledge in
                developing front end web applications, and always open to new
                directions of programming.
              </p>
              <p>
                Dedicated to creating and optimizing interactive, user-friendly
                and feature-rich web applications. Exposure to Front-end web
                development, Progressive Web Application (PWA) development.
                Believe that continuous learning and belief are the key factors
                for achieving personal and professional success. Have the desire
                to learn and develop something new, as well as adhere to the
                rule "Good code is beautiful code" and try to follow all
                standards of the modern development process.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default About;
